import { AnaColumn } from "../forms-template.service";

export const crmCensimento: AnaColumn[] = [
    {
        itemType: 'group',
        caption: '',
        class: 'mb-5',
        colCount: 4,
        colSpan: 2,
        data: [
            // {
            //     type: 'campo',
            //     dataField: 'COD',
            //     visible: false,
            //     colVisible: false,
            //     dataType: 'string',
            //     caption: 'ID',
            //     colAlignment: 'center',
            //     nCol: 5,
            // },
            {
                type: 'campo',
                dataField: 'pecNica',
                visible: true,
                dataType: 'string',
                caption: 'Pec nostra azienda',
                colAlignment: 'center',
                nCol: 6,
                class: 'crm_contatti_editor me-2 ',
                validation: [
                    {type: 'required', message: 'Campo Pec nostra azienda obbligatorio.'}
                ]
            },
            {
                type: 'campo',
                dataField: 'password',
                visible: true,
                dataType: 'string',
                caption: 'Password',
                colAlignment: 'center',
                nCol: 4,
                class: 'crm_contatti_editor me-2 ',
                validation: [
                    {type: 'required', message: 'Campo password obbligatorio.'}
                ]
            },
            { type: 'empty' },
            { type: 'empty' },
            { type: 'empty' },
            {
                type: 'campo',
                dataField: 'pecCliente',
                visible: true,
                dataType: 'string',
                caption: 'Pec cliente',
                colAlignment: 'center',
                nCol: 6,
                class: 'crm_contatti_editor me-2 ',
                validation: [
                    {type: 'required', message: 'Campo Pec cliente obbligatorio.'}
                ]
            },
            {
                type: 'campo',
                dataField: 'oggettoMail',
                visible: true,
                dataType: 'string',
                caption: 'Oggetto mail',
                colAlignment: 'center',
                nCol: 4,
                class: 'crm_contatti_editor me-2 ',
                validation: [
                    {type: 'required', message: 'Campo Oggetto mail obbligatorio.'}
                ]
            },
            { type: 'empty' },
            { type: 'empty' },
            { type: 'empty' },
            { type: 'empty' },
            {
                type: 'campo',
                dataField: 'testoMail',
                visible: true,
                dataType: 'string',
                caption: 'Testo mail',
                colAlignment: 'center',
                nCol: 10,
                height: '250px',
                editorType: "dxTextArea",
                class: 'crm_contatti_editor me-2 p-1 ',
                validation: [
                    {type: 'required', message: 'Campo Testo mail obbligatorio.'}
                ]
            },
        ]
    }
];